(function () {

    'use strict';

    angular
        .module('ib-discounts-module')
        .controller('DiscountsController', DiscountsController);


    function DiscountsController () {

        const vm = this;
        activate();

        function activate () {

        }

    }

})();